import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface DashboardSummary {
  currency: string;
  ventasMes: number;
  comprobantesMes: number;
  aceptacionPct: number;
  aceptacion: { aceptados: number; observados: number; rechazados: number };
  ventasPorDia: Array<{ dia: number; total: number }>;
  porCobrar: number;
  vencido: number;
  aging: Array<{ label: string; val: number; color: string }>;
  comprasMes: number;
  ordenesCompra: number;
  gastosMes: number;
  porPagar: number;
  saldoCuentas: number;
  cuentasCount: number;
  flujoCaja: Array<{ m: string; in: number; out: number }>;
  cajaAbierta: boolean;
  cajaEsperada: number | null;
  cajaMetodos: Array<{ metodo: string; monto: number }>;
  topProductos: Array<{ name: string; qty: number; total: number }>;
}

export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard-summary'],
    queryFn: async () => (await apiClient.get<DashboardSummary>('/dashboard/summary')).data,
    retry: false,
  });
}
